import { useEffect } from 'react'
import { LOCALSTORAGE_TOKENS } from '../../../constants'

export const useLoading = setTypeUser => {
  useEffect(() => {
    localStorage.setItem(LOCALSTORAGE_TOKENS.type, 'other')
    setTypeUser('other')
  }, [setTypeUser])
}
